import * as angular from "angular";
import { DialogUtils } from "../../../../helper/dialog.helper";
import { ChartHelper } from "../../../result/chart.helper";

let WidgetStyleFormComponent = {
    selector: "vcWidgetStyleForm",
    templateUrl:
        "/angular/components/dashboard/widget/style/widget-style-form.component.html",
    bindings: {
        widget: "=",
    },
    controller: class WidgetStyleFormController {
        // * bindings for typescript compiler *
        public widget: any;
        // ************************************

        public dialog: DialogUtils;
        public chartHelper: ChartHelper;
        public disabled: ChartHelper;
        public labelFontSizes: number[] = [6, 8, 10, 12, 14, 16, 18, 20];
        public figureFontSizes: number[] = [
            12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 56, 64, 80, 100,
        ];
        public legendPositions: string[] = ["top", "bottom", "left", "right"];

        constructor(
            $scope: any,
            __app_type: string,
            DialogUtils: DialogUtils,
            ChartHelper: ChartHelper
        ) {
            this.dialog = DialogUtils;
            this.chartHelper = ChartHelper;
        }
    },
};

angular
    .module("dashboard")
    .component(WidgetStyleFormComponent.selector, WidgetStyleFormComponent);
